export const getLoggedInUserName = () => {
    const userProfileData = localStorage.getItem('userMetaData');
    return userProfileData ? JSON.parse(userProfileData).fullName : null;
};